var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 48,
    viewBox: "0 0 36 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10146_49742)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_10146_49742)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 43.5,
    rx: 6,
    ry: 3,
    fill: "black",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_10146_49742",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 34,
    height: 43,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1,
    y: 1,
    width: 34,
    height: 43
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8739 30.0948C30.5889 27.3645 33 22.9638 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 22.9638 5.41111 27.3645 9.12607 30.0948C11.9491 32.222 15.9284 35.5777 16.8432 40.9793C16.94 41.5514 17.4197 41.9954 18 41.9954C18.5803 41.9954 19.06 41.5514 19.1568 40.9793C20.0716 35.5777 24.0509 32.222 26.8739 30.0948Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8739 30.0948C30.5889 27.3645 33 22.9638 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 22.9638 5.41111 27.3645 9.12607 30.0948C11.9491 32.222 15.9284 35.5777 16.8432 40.9793C16.94 41.5514 17.4197 41.9954 18 41.9954C18.5803 41.9954 19.06 41.5514 19.1568 40.9793C20.0716 35.5777 24.0509 32.222 26.8739 30.0948Z",
    fill: "#0B7CDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8739 30.0948L25.9856 28.8861L25.9784 28.8914L25.9712 28.8968L26.8739 30.0948ZM9.12607 30.0948L10.0288 28.8968L10.0216 28.8914L10.0144 28.8861L9.12607 30.0948ZM16.8432 40.9793L18.3221 40.7288L16.8432 40.9793ZM19.1568 40.9793L17.6779 40.7288L17.6779 40.7288L19.1568 40.9793ZM27.7622 31.3034C31.8452 28.3027 34.5 23.4613 34.5 18H31.5C31.5 22.4664 29.3326 26.4263 25.9856 28.8861L27.7622 31.3034ZM34.5 18C34.5 8.8873 27.1127 1.5 18 1.5V4.5C25.4558 4.5 31.5 10.5442 31.5 18H34.5ZM18 1.5C8.8873 1.5 1.5 8.8873 1.5 18H4.5C4.5 10.5442 10.5442 4.5 18 4.5V1.5ZM1.5 18C1.5 23.4613 4.15479 28.3027 8.23776 31.3034L10.0144 28.8861C6.66744 26.4263 4.5 22.4664 4.5 18H1.5ZM18.3221 40.7288C17.3018 34.7038 12.8729 31.0399 10.0288 28.8968L8.22337 31.2927C11.0253 33.4041 14.5551 36.4516 15.3642 41.2297L18.3221 40.7288ZM18 40.4954C18.1029 40.4954 18.1877 40.5369 18.2389 40.5827C18.2868 40.6254 18.3133 40.677 18.3221 40.7288L15.3642 41.2297C15.5713 42.4526 16.6184 43.4954 18 43.4954V40.4954ZM17.6779 40.7288C17.6867 40.677 17.7132 40.6254 17.7611 40.5827C17.8123 40.5369 17.8971 40.4954 18 40.4954V43.4954C19.3816 43.4954 20.4287 42.4526 20.6358 41.2297L17.6779 40.7288ZM25.9712 28.8968C23.1271 31.0399 18.6982 34.7038 17.6779 40.7288L20.6358 41.2297C21.4449 36.4516 24.9747 33.4041 27.7766 31.2927L25.9712 28.8968Z",
    fill: "url(#paint0_linear_10146_49742)",
    mask: "url(#path-2-outside-1_10146_49742)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_10146_49742",
    x: 9,
    y: 37.5,
    width: 18,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_10146_49742"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10146_49742",
    x1: 18,
    y1: 3,
    x2: 18,
    y2: 41.9954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10146_49742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.1a2d8dbff798e1511bcce6072e081e6a.svg";
export { ForwardRef as ReactComponent };